(function() {
    var filterBy = document.getElementById('BlogTagFilter');
  
    if (!filterBy) {
      return;
    }
  
    filterBy.addEventListener('click', function(event) {
      var target = event.target;
  
      // Find the closest parent li element with the data-value attribute
      var listItem = target.closest('li[data-value]');
  
      if (listItem) {
        var selectedValue = listItem.getAttribute('data-value');
        sessionStorage.setItem('selectedBlogTag', selectedValue);
        location.href = selectedValue;
      }
    });
  
    var storedValue = sessionStorage.getItem('selectedBlogTag');
    if (storedValue) {
      var listItems = filterBy.getElementsByTagName('li');
      for (var i = 0; i < listItems.length; i++) {
        if (listItems[i].getAttribute('data-value') === storedValue) {
          listItems[i].classList.add('selected');
        } else {
          listItems[i].classList.remove('selected');
        }
      }
    }
  })();
  